import type { TFunction } from "i18next";
import { z } from "zod";
import {
  getOperationsDocumentsSchema,
  getOptionalOperationsCommentsSchema,
  OPERATIONS_DETAILS_MAX_LENGTH,
  OPERATIONS_DOCUMENTS_MAX_FILES,
} from "./operationsDisputeSchema";

export const NO_DISPUTE_DOCUMENT_FIELD = "noDisputeDocuments" as const;
export const NO_DISPUTE_COMMENTS_MAX_LENGTH = OPERATIONS_DETAILS_MAX_LENGTH;
export const NO_DISPUTE_DOCUMENTS_MAX_FILES = OPERATIONS_DOCUMENTS_MAX_FILES;

export const getNoDisputeDrawerSchema = (t: TFunction, includeAssociatedMovement = true) =>
  z.object({
    associatedMovementId: includeAssociatedMovement
      ? z.string().min(
          1,
          t("form-validation.mandatory", {
            label: t("vessel-call.operations.associated-movement"),
          }),
        )
      : z.string().optional(),
    comments: getOptionalOperationsCommentsSchema(
      t,
      t("vessel-call.operations.no-dispute-comments"),
    ),
    [NO_DISPUTE_DOCUMENT_FIELD]: getOperationsDocumentsSchema(
      t,
      t("vessel-call.operations.no-dispute-document"),
    ),
  });
